module.exports = __webpack_public_path__ + "img/1 (31).f36d208e.png";